import React, { useState } from 'react'
import { AgencyPaymentSchemeDetails, WeedingPassDetails } from './WeedingPassDetails'
import { useEffect } from 'react'
import { getAgencyPaymentScheme, getWeedingPass, updateWeedingPassMessage, weedingPassListDetails } from '../../../store/slices/groupFiles/thunks'
import { useDispatch, useSelector } from 'react-redux'
import { AddWeedingPass } from './AddWeedingPass'
import { getCategoriesList } from '../../../store/slices/catalogue/thunks'
import { MyTextInput } from '../../ui/controls/MyTextInput'

export const WeedingPass = ({ groupFile }) => {
  const { categoriesList } = useSelector((state) => state.catalogue); 
  const dispatch = useDispatch();
  const [addWeedingPass, setAddWeedingPass] = useState(false);
  const [message, setMessage] = useState(groupFile.weedingPassMessage || "");


  useEffect(() => {
    dispatch(getWeedingPass(groupFile.id));
  }, [])

  useEffect(() => {
    dispatch(getCategoriesList());
  }, [])

  const save = () => {
    const success = () => { };
    dispatch(updateWeedingPassMessage(message, groupFile.id, success));
  }

  return (
    <div style={{ marginTop: 20 }}>
      <div style={{ fontSize: 20 }}>Weeding Pass Adicionales</div>

      <div className="col-lg-12 col-md-12 mt-3">
        <div className="row">
          <label>Mensaje a mostrar:</label>
        </div>
        <div className="row">
          <textarea className="form-control" type="text" rows="2" value={message}
            onChange={e => setMessage(e.target.value)}
          />
        </div>
        <div className="row" style={{ justifyContent: "flex-end"}} >
          <button className="btn btn-light" style={{ marginTop: 20, marginBottom: 20, width:100 }} onClick={() => save(true)} >Guardar</button>
        </div>
      </div>


      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <button className="btn btn-light btn-icon"
          onClick={() => setAddWeedingPass(true)} >Agregar Weeding Pass</button>
        <button className={`btn text-white btn-primary`}
          onClick={() => dispatch(weedingPassListDetails(groupFile.id))} >Descargar Weeding Pass List</button>
      </div>

      <AddWeedingPass groupFile={groupFile} categories={categoriesList} isOpen={addWeedingPass} setIsOpen={setAddWeedingPass} />
      <WeedingPassDetails groupFile={groupFile} categories={categoriesList} code={groupFile} />
    </div>
  )
}
